import type { BulkTaskResult } from '@hygge/shared';
import { api } from './api';

export interface BulkTaskPayload {
  taskKeys: string[];
  action: 'move' | 'assign' | 'delete' | 'move_board';
  statusId?: string;
  assigneeId?: string | null;
  /** Destination board id (required for action="move_board"). */
  targetBoardId?: string;
}

export async function bulkTaskAction(
  boardId: string,
  payload: BulkTaskPayload,
): Promise<BulkTaskResult> {
  const { data } = await api.post<BulkTaskResult>(`/boards/${boardId}/tasks/bulk`, payload);
  return data;
}
